import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/search.svg
 */
const IconSearch: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.077 21.304l-5.484-5.484c.365-.431.692-.892.978-1.379a9.586 9.586 0 000-9.627 9.777 9.777 0 00-3.518-3.518 9.58 9.58 0 00-9.627 0 9.753 9.753 0 00-3.518 3.518 9.556 9.556 0 000 9.627 9.692 9.692 0 003.518 3.518 9.56 9.56 0 009.543.056l5.686 5.683a1.024 1.024 0 001.453 0l.985-.932a1.03 1.03 0 000-1.453l-.016-.009zM10.23 17.397a7.557 7.557 0 01-3.888-1.05 7.845 7.845 0 01-2.838-2.838 7.726 7.726 0 010-7.764 7.854 7.854 0 012.838-2.837 7.727 7.727 0 017.764 0 7.823 7.823 0 012.838 2.837 7.724 7.724 0 010 7.764 7.817 7.817 0 01-2.838 2.838 7.546 7.546 0 01-3.876 1.05z"
      fill="currentColor"
    />
  </svg>
);

export default IconSearch;
